// Pure helper: bytes → human-readable string mit deutscher Lokalisierung.
//
// Schwellen:
//   < 1024      → "X B"            (Math.floor — bytes sind ganzzahlig)
//   < 1024²     → "X KB"           (Math.round, no decimal)
//   < 1024³     → "X,Y MB"         (1 decimal)
//   ≥ 1024³     → "X,Y GB"         (1 decimal, no TB-tier — DAM-Volume ~100 GB realistisch)
//
// Defensive: NaN, negative, Infinity → "—" (Typografisches Em-Dash).
//
// Locale: deutsche Komma-als-Dezimaltrenner via `toLocaleString('de-DE', ...)`.
// Wir nutzen NICHT `Intl.NumberFormat` mit `style: 'unit'` — das returnt
// die Number mit narrow-no-break-space (U+202F) zwischen Wert + Einheit,
// was font-mono-Layout brechen kann. Manuelles ASCII-Space-Concat ist robuster.
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';

  if (bytes < 1024) return `${Math.floor(bytes)} B`;

  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;

  const mb = kb / 1024;
  if (mb < 1024) return `${formatDecimal(mb, 1)} MB`;

  const gb = mb / 1024;
  return `${formatDecimal(gb, 1)} GB`;
}

// Format mit N Nachkommastellen, deutsche Lokalisierung (Komma als Trenner).
function formatDecimal(value: number, decimals: number): string {
  return value.toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
